import React, { useEffect, useState } from 'react';
import { Form, Row, Col, FloatingLabel } from "react-bootstrap";
import { NumericFormat } from "react-number-format";

export default function Payment({ sendTransactionDataToParent, loaderRunning }) {

    //field validation state:
    const [amountInvalidMessage, setAmountInvalidMessage] = useState('');

    //show $ symbol state:
    const [showDollarSign, setShowDollarSign] = useState(false);

    //data object state:
    let transactionObject = { amount: "", invoiceNumber : "", poNumber : "", description : ""  };
    const [transactionData, setTransactionData] = useState(transactionObject);

    //Amount focus:
    const handleFocusAmount = () => {
        let inputAmount = transactionData.amount.trim();

        if (inputAmount === "") {
            setShowDollarSign(true);
        }
    };

    //Amount blur:
    const handleBlurAmount = () => {
        let inputAmount = transactionData.amount.trim();

        if (inputAmount === "") {
            setShowDollarSign(false);
            setAmountInvalidMessage("Payment Amount is required");
        }
    };

    //Input change event:
    const handleTransactionChangeInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        if (name === 'amount') {
            setAmountInvalidMessage('');
        }
        setTransactionData({ ...transactionData, [name]: value });
    };

    //send data to main component:
    useEffect(() => {
        sendTransactionDataToParent(transactionData)
    }, [transactionData, sendTransactionDataToParent]);


    return (
        <>
            <Row className="gx-2">
                <Col md="4" style={{ position: "relative" }}>
                    {/* Show $ sign if the amount is empty or if the user has typed something */}
                    {showDollarSign && <div className="dollar-sign">$</div>}

                    <FloatingLabel controlId="floatingPaymentAmount"
                        label={
                            <span className={amountInvalidMessage ? 'text-danger' : ''}>
                                {amountInvalidMessage ? amountInvalidMessage : "Payment Amount"}
                            </span>}
                        className="mb-2" >
                        <NumericFormat
                            id="floatingPaymentAmount"
                            decimalSeparator="."
                            thousandSeparator=","
                            decimalScale={2}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            className={`dollar-textbox form-control ${amountInvalidMessage ? 'border-danger' : ''}`}
                            placeholder="Payment Amount"
                            name="amount"
                            value={transactionData.amount}
                            disabled={loaderRunning}
                            onChange={handleTransactionChangeInput}
                            onFocus={handleFocusAmount}
                            onBlur={handleBlurAmount}
                            required
                        />
                    </FloatingLabel>
                </Col>
                <Col md="4">
                    <FloatingLabel controlId="floatingInvoiceNumber" label="Invoice Number" className="mb-2">
                        <Form.Control
                        type="text" 
                        placeholder="Invoice Number"
                        name="invoiceNumber"
                        value={transactionData.invoiceNumber}
                        disabled={loaderRunning}
                        onChange={handleTransactionChangeInput}
                        />
                    </FloatingLabel>
                </Col>
                <Col md="4">
                    <FloatingLabel controlId="floatingPONumber" label="PO Number" className="mb-2">
                        <Form.Control 
                        type="text"
                        placeholder="PO Number" 
                        name="poNumber" 
                        value={transactionData.poNumber}
                        disabled={loaderRunning}
                        onChange={handleTransactionChangeInput} />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row>
                <Col className="mb-3">
                    <FloatingLabel controlId="floatingDescprition" label="Descprition">
                        <Form.Control 
                        as="textarea" 
                        placeholder="Descprition" 
                        name="description" 
                        value={transactionData.description} 
                        disabled={loaderRunning}
                        onChange={handleTransactionChangeInput} />
                    </FloatingLabel>
                </Col>
            </Row>
        </>
    )
}
